const FAQ = [
    {
        title: 'General',
        questions: [
            {
                id: 1,
                question: 'What is Paylinx?',
                answer: 'Paylinx is an Australian Fintech company that provides payment and marketing services to merchants through WeChat, WeChat Pay and Alipay. Paylinx is an integrated mobile payment platform.',
            },
            {
                id: 2,
                question: 'What is a standalone QR Code?',
                answer: 'A QR code is a machine-readable code consisting of an array of black and white squares, typically used for storing URLs or other information for reading by the camera on a smartphone. To scan a QR code with WeChat, open the app and tap on the ‘Discover’ menu. Then select ‘Scan QR code’.',
            }
            
        ]
    },
    {
        title: 'Wechat',
        questions: [
            {
                id: 1,
                question: 'What is WeChat?',
                answer: 'With over 1.1 Billion monthly active user accounts as of April 2018, WeChat has become one of the most impactful mobile products on the planet. Since its start as a chat app, WeChat has grown to become a market-leading platform by connecting people, services, and businesses around the world.',
            },
            {
                id: 2,
                question: 'What is a WeChat Official Account?',
                answer: 'WeChat Official Brand Accounts are a service launched for companies, organizations, government, media, celebrities and organizations. Official accounts can be used to promote brands to millions of users. For merchants, Official accounts are an essential way to reach and connect with customers.',
            },
            {
                id: 3,
                question: 'How do I follow an Official Brand Account?',
                answer: 'Either search for it using the unique WeChat ID or by scanning the unique QR code. To add using the WeChat ID, simply tap on the plus button in your “Chat” window (top-right), then tap Add Contacts; Official Accounts and type the WeChat ID in the search bar.',
            },
            {
                id: 4,
                question: 'How do I share an Official Brand Account with my contacts?',
                answer: 'In a chat window, tap on the “+” icon in the bottom right corner; select Name Card; select Official Accounts right at the top of your contact list; select the Official Account you wish to share.',
            },
            {
                id: 5,
                question: 'Once I follow an Official Brand Account, where do I find the account in WeChat?',
                answer: 'Once you have followed an Official Brand Account you will find them under your Contacts tab by tapping on Official Accounts or you can search for the account in your Contacts tab.',
            }       
        ]
    },
    {
        title: 'Wechat Pay',
        questions: [
            {
                id: 1,
                question: 'What is WeChat Pay?',
                answer: 'WeChat Pay is the mobile wallet function of the WeChat app with over 300m monthly active users. Combined with WeChat Official Accounts, WeChat Pay is a powerful tool for merchants reaching and staying connected with Chinese consumers. WeChat Pay allows easy, secure, and private payment in stores, in apps, and on the web. Accepting WeChat Pay is faster than accepting traditional credit and debit cards and more secure. Every transaction requires a pin authentication passcode sent to the customer phone number and card numbers are kept confidential in the system.',
            },
            {
                id: 2,
                question: 'How will overseas vendors benefit from WeChat Pay?',
                answer: 'Chinese people love to travel. Offering WeChat Pay is a recognised trusted payment option that Chinese customers will choose every time. Buyer accounts follow the overseas merchant’s Official Brand account automatically. They (and their friends) can still receive marketing, promotions and make purchases through this account even after they return home to China.',
            },
            {
                id: 3,
                question: 'How do I let my customers know they can pay with WeChat Pay?',
                answer: 'Display the WeChat Pay mark prominently at your point of sale. Download the mark to use within email, and on your website. Order WeChat Pay decals to put on your storefront window. We will assist to promote your business on WeChat.',
            },
            {
                id: 4,
                question: 'How do I learn more about WeChat Pay?',
                answer: 'Contact PayLinx to get setup.',
            },     
        ]
    },
    {
        title: 'Merchants',
        questions: [
            {
                id: 1,
                question: 'How do Merchants offer WeChat Pay to customers?',
                answer: 'WeChat Pay is the mobile wallet function of the WeChat app with over 300m monthly active users. Combined with WeChat Official Accounts, WeChat Pay is a powerful tool for merchants reaching and staying connected with Chinese consumers. WeChat Pay allows easy, secure, and private payment in stores, in apps, and on the web. Accepting WeChat Pay is faster than accepting traditional credit and debit cards and more secure. Every transaction requires a pin authentication passcode sent to the customer phone number and card numbers are kept confidential in the system.',
            },
            {
                id: 2,
                question: 'Do merchants apply individually for chain stores?',
                answer: 'Merchants need to apply for each separate company or bank account.',
            },
            {
                id: 3,
                question: 'How can merchants check transaction history?',
                answer: 'Use your provided login credentials on the web or through WeChat. After linking your store in WeChat, each transaction is sent real time.',
            },
            {
                id: 4,
                question: 'How does settlement happen?',
                answer: 'If a shopper spends AUD$100 with a merchant, WeChat Pay will debit the same amount from their WeChat Wallet under a real-time exchange rate. The merchant is then credited the AUD$100. The exchange rate does not impact merchants in any way. Settlement fees are competitive with your existing card providers. These are paid by the merchant or passed-on to the customer (all or in-part – at merchant discretion).',
            },     
        ]
    },
    {
        title: 'Pricing/Costs',
        questions: [
            {
                id: 1,
                question: 'Are there any costs to apply or maintain a WeChat Pay account?',
                answer: 'No. There are no costs to setup or maintain your account and you can close your account at any time.',
            },
            {
                id: 2,
                question: 'Does WeChat Pay have charge limits?',
                answer: 'No. But customer’s own banks have their own daily charge limits that vary.',
            },   
        ]
    },
    {
        title: 'Technical Support',
        questions: [
            {
                id: 1,
                question: 'What privacy and security measures does WeChat Pay have in place for users and merchants?',
                answer: 'WeChat Pay is the safer way to pay. When you make a purchase, WeChat Pay uses a device-specific number and unique transaction code. User card numbers are never shared by WeChat.',
            },
            {
                id: 2,
                question: 'Are Merchants liable for fraud on WeChat Pay transactions?',
                answer: 'Within stores, WeChat Pay transactions are treated in the same way as your current credit and debit transactions. You’ll have the same liability rules applied to WeChat Pay transactions.',
            },   
        ]
    },
]

export default FAQ;


// WEBPACK FOOTER //
// ./src/component/header/searchBar/FAQ.js